<template>
  <div>
    <div class="input-wrapper" :style="computedStyle">
      <div class="input-icon"></div>
      <input
        class="tx-input"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxlength"
        :min="min"
        :max="max"
        @input="handleInput"
        @change="handleChange"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown="handleKeydown"
        @keyup="handleKeyup"
        @keypress="handleKeypress"
        @keyup.enter="handleEnter"
      />
      <div :style="popoupStyle" class="input-history px-16 py-16" v-if="show_history.length > 0">
          <p @click="selct_item(item)" v-for="item,index in show_history" :key="index">{{ item }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import config from '@img/config.json';
import px2vw from '@/utils/px2vw_v2';
import { computed } from 'vue';
const { support_image, is_mobile } = inject('GlobalStore');
const { search_record, set_search_record } = inject('GlobalData');

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '请输入角色名称',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: [String, Number],
    default: null,
  },
  min: {
    type: [String, Number],
    default: null,
  },
  max: {
    type: [String, Number],
    default: null,
  },
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: false,
  },
});

// Emits 定义
const emit = defineEmits([
  'update:modelValue',
  'input',
  'change',
  'focus',
  'enter',
  'blur',
  'clear',
  'keydown',
  'keyup',
  'keypress',
]);

const bg = computed(() => {
  let src = config[props.src].src;
  return `${src}.${support_image.value}`;
});

const computedStyle = computed(() => {
  const size = config[props.src];

  return {
    backgroundImage: `url(${bg.value})`,
    backgroundRepeat:'round',
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

const popoupStyle = computed(() => {
  let bg = `${config['xialakuan-menpai'].src}.${support_image.value}`;

  return {
    'border-image-source': `url(${bg})`,
    width: px2vw(300, is_mobile.value),
    'border-image-slice': '40 40 45 64 fill',
    'border-image-width': '40px 40px 45px 64px',
  };
});

// 事件处理函数
const handleInput = (event) => {
  const value = event.target.value;
  emit('update:modelValue', value);
  emit('input', value, event);
};

const handleChange = (event) => {
  emit('change', event.target.value, event);
};

const handleFocus = (event) => {
  emit('focus', event);
};

const handleBlur = (event) => {
  emit('blur', event);
};

const handleClear = () => {
  emit('update:modelValue', '');
  emit('clear');
  emit('input', '');

  // 聚焦到输入框
  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.focus();
    }
  });
};

const handleKeydown = (event) => {
  emit('keydown', event);
};

const handleKeyup = (event) => {
  emit('keyup', event);
};

const handleKeypress = (event) => {
  emit('keypress', event);
};

const handleEnter = (event) => {
  emit('enter', event);
};

const selct_item = (item) => {
  emit('update:modelValue', item);
}

const show_history =  computed(() => {
  if(!search_record.value) {
    return []
  }
  if (!props.modelValue) {
    return search_record.value;
  }
  return search_record.value.filter((item) => item.includes(props.modelValue));
})

</script>

